import React from 'react';
import JsonView from 'react18-json-view';
import { processConfigKeyParams } from '../../../../api';

/**
 * Request 响应渲染器
 */
function RequestRenderer({ request, paramsList }) {
  const _request = JSON.parse(JSON.stringify(request));
  
  if (!_request.PdfPageNumber) {
    delete _request.PdfPageNumber;
  }
  
  // 处理 configKey 参数（通用处理，用于 Request 显示）
  const processedRequest = paramsList
    ? processConfigKeyParams(_request, paramsList)
    : _request;

  return (
    <div className="ocr-code__pre">
      <JsonView
        src={processedRequest}
        keyName={false}
        theme="winter-is-coming"
        displayDataTypes={false}
      />
    </div>
  );
}

export default RequestRenderer;
